"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.pathToArr = pathToArr, exports.getSlashStrPath = getSlashStrPath, exports.getDotStrPath = getDotStrPath, exports.combineReducers = combineReducers, exports.preserveValuesFromState = preserveValuesFromState, exports.recursiveUnset = recursiveUnset;

var _unset2 = _interopRequireDefault(require("lodash/fp/unset")),
    _pick2 = _interopRequireDefault(require("lodash/pick")),
    _size2 = _interopRequireDefault(require("lodash/size")),
    _get2 = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

function pathToArr(path) {
  return path ? path.split(/\//).filter(function (p) {
    return !!p;
  }) : [];
}

function getSlashStrPath(path) {
  return pathToArr(path).join("/");
}

function getDotStrPath(path) {
  return pathToArr(path).join(".");
}

function combineReducers(reducers) {
  return function () {
    var state = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
        action = 1 < arguments.length ? arguments[1] : void 0;
    return Object.keys(reducers).reduce(function (nextState, key) {
      return nextState[key] = reducers[key](state[key], action), nextState;
    }, {});
  };
}

function preserveValuesFromState(state, preserveSetting, nextState) {
  if ("function" == typeof preserveSetting) return preserveSetting(state, nextState);
  if (!0 === preserveSetting) return nextState ? _objectSpread({}, state, {}, nextState) : state;
  if (Array.isArray(preserveSetting)) return (0, _pick2.default)(state, preserveSetting);
  throw new Error("Invalid preserve parameter. It must be an Object or an Array");
}

function recursiveUnset(path, obj) {
  var isRecursiveCall = !!(2 < arguments.length && arguments[2] !== void 0) && arguments[2];
  if (!path) return obj;
  if (0 < (0, _size2.default)((0, _get2.default)(obj, path)) && isRecursiveCall) return obj;
  var objectWithRemovedKey = (0, _unset2.default)(path, obj),
      newPath = path.match(/\./) ? path.replace(/\.[^.]*$/, "") : "";
  return recursiveUnset(newPath, objectWithRemovedKey, !0);
}